import {
  OfferDemandCard,
  OfferDemandCardInfo,
  OfferDemandCardLabel,
  OfferDemandCardMainValue,
  OfferDemandCardsContainer,
  OfferDemandCardsContent,
  OfferDemandCardSecondaryValue,
  OfferDemandNoData,
} from './offerDemand.styles';
import OfferByPurposeChart from './offerDemandPurposeGraph.component';
import { ReactComponent as Asset } from '../../../assets/images/asset.svg';
import { ReactComponent as Building } from '../../../assets/images/building.svg';
import { OfferDemandDataModel } from '../../../types/indicators.interfaces';
import { useIntl } from 'react-intl';
import noData from '../../../assets/images/error.png';
export const OfferDemandInfo = (props: OfferDemandDataModel) => {
  const intl = useIntl();
  return (
    <OfferDemandCardsContent>
      <OfferDemandCardsContainer>
        <OfferDemandCard>
          <OfferDemandCardLabel align="start">
            {intl.formatMessage({
              id: 'glossary.supply_and_demand.supplyByPurpose.title',
            })}
          </OfferDemandCardLabel>
          {props.offer_by_purpose &&
          (props.offer_by_purpose.rent !== null ||
            props.offer_by_purpose.sale !== null) ? (
            <OfferByPurposeChart data={props.offer_by_purpose} />
          ) : (
            <OfferDemandNoData>
              {intl.formatMessage({ id: 'offerDemand.noDataForGraph' })}
              <img src={noData} alt="no data" width={'20%'} />
            </OfferDemandNoData>
          )}
        </OfferDemandCard>
        <OfferDemandCard>
          <OfferDemandCardLabel>
            {intl.formatMessage({
              id: 'glossary.supply_and_demand.mostDemandedHousing.title',
            })}
          </OfferDemandCardLabel>
          <OfferDemandCardInfo>
            <OfferDemandCardMainValue>
              {props.most_demanded_house.range ?? '-'}
            </OfferDemandCardMainValue>
            <OfferDemandCardSecondaryValue>
              {intl.formatMessage({
                id: 'glossary.supply_and_demand.size',
              })}{' '}
              {props.most_demanded_house.tag ?? '-'}
            </OfferDemandCardSecondaryValue>
          </OfferDemandCardInfo>
          <Asset />
        </OfferDemandCard>
        <OfferDemandCard>
          <OfferDemandCardLabel>
            {intl.formatMessage({
              id: 'glossary.supply_and_demand.averageBuildingAge.title',
            })}
          </OfferDemandCardLabel>
          <OfferDemandCardInfo>
            {props.mean_housing_age ? (
              <OfferDemandCardMainValue>
                {props.mean_housing_age}
              </OfferDemandCardMainValue>
            ) : (
              <OfferDemandCardSecondaryValue>-</OfferDemandCardSecondaryValue>
            )}
            <OfferDemandCardSecondaryValue>
              {intl.formatMessage({
                id: 'glossary.supply_and_demand.years',
              })}
            </OfferDemandCardSecondaryValue>
          </OfferDemandCardInfo>
          <Building />
        </OfferDemandCard>
      </OfferDemandCardsContainer>
    </OfferDemandCardsContent>
  );
};
